import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

import { Observable } from 'rxjs';

import { AuthService } from '../services/auth.service';
import { LocalStorageService } from '../services/local-storage.service';

@Injectable({
    providedIn: 'root',
})
export class SubscriptionGuard implements CanActivate {

    constructor(private router: Router,
        private authService: AuthService,
        private localStorageService: LocalStorageService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        if (!this.authService.getActiveSubscriptionId()) {
            this.localStorageService.redirect.set(state.url);
            this.router.navigate(['/', 'auth', 'login']);
            return false;
        } else {
            return true;
        }
    }
}
